import moment from 'moment';
import _, { omit } from 'lodash';
import helpers from './helpers';
import { api } from '$$store/api';
import tasksHelpers from '$$store/tasks/helpers';
import constants from '$$helpers/constants';
import globalToast from '$$vueCmp/toast';

const OPTIONS_REQUIRED_TO_TASKS_UPDATE = [
  'colors', 'priority', 'status', 'resources',
  'description', 'resources', 'progress', 'dates',
];

export default {
  async copy({ commit }, taskId) {
    try {
      const copiedData = helpers.prepareDataForCopy(taskId);

      commit('hasCopiedTask', true);
      commit('setCopiedTask', { ...copiedData });
      commit('setCopyPastError', null);

      globalToast.info(__('task_was_copied'));
    } catch (error) {
      console.error(error);
    }
  },

  setCopyPasteError({ commit, rootGetters }, { taskIds = [], text }) {
    const copiedTask = rootGetters['copyPaste/copiedTask'];

    if (!copiedTask || !text || !taskIds.length) {
      return;
    }

    const copyTasks = _.map(
      rootGetters['tasksModel/getAllChildByTask'](
        +copiedTask.ganttId,
        +copiedTask.taskId,
      ), 'id');

    copyTasks.push(+copiedTask.taskId);

    if (copyTasks.find(tid => taskIds.includes(tid))) {
      commit('setCopyPastError', text);
    }
  },

  async paste({ commit, state }, data) {
    try {
      const pastedData = helpers.prepareDataForPaste(data, state.copiedTask);

      commit('setCopiedTask', { ...pastedData });
      commit('hasCopiedTask', true);
      await api.post('/task/copy-tasks', { ...pastedData });
    } catch (error) {
      console.error(error);
    }
  },

  async afterPasteTasks({ commit, dispatch, getters }, data) {
    const taskMap = JSON.parse(data.taskMap);
    // const { data: specialPasteConfig } = await axios.get(
    //   '/api/task/copy-settings',
    //   { params: { user_id: user.id, project_id: data.newGanttId } },
    // );

    delete data.taskMap;
    // delete data.copiedValues;

    commit('setTaskMap', taskMap);
    // commit('setSpecialPasteConfig', { ...specialPasteConfig });
    commit('assignCopyData', {
      ...omit(data, ['pastedTasksData', 'updatedTasks', 'userCustomColumns', 'socketId']),
      copyRootTaskId: data.copyRootTaskId,
    });

    commit('insertingProcess', { flag: true, isSpecialPaste: data.isSpecialPaste });

    dispatch('processPastedTasks', data);

    // if (!data.isSpecialPaste) {
    //   commit('setPopupCoordinates', helpers.calculateSpecialPopupCoordinates(data.copyRootTaskId));
    //
    //   specialPasteConfig.show_always_popup
    //     ? commit('toggleSpecialPastePopup', true)
    //     : commit('setSpecialPasteIconId', data.copyRootTaskId);
    // }

    commit('insertingProcess', { flag: false, isSpecialPaste: data.isSpecialPaste });
  },

  processPastedTasks({ dispatch, commit }, data) {
    const changedValues = [...data.copiedValues];

    if (data.removedValues) {
      changedValues.push(...data.removedValues);
    }

    const tasksModel = tasksHelpers.prepareProjectTasksData(data.pastedTasksData);
    const projectId = data.newGanttId;

    data.updatedTasks.forEach(task => {
      if (task.deadline) {
        task.deadline = moment(task.deadline, constants.TASK_DATES_FORMAT).toDate();
      }

      if (_.isString(task.start_date)) {
        task.start_date = moment(task.start_date, constants.TASK_DATES_FORMAT).toDate();
      }

      if (_.isString(task.end_date)) {
        task.end_date = moment(task.end_date, constants.TASK_DATES_FORMAT).toDate();
      }
    });

    if (data.userCustomColumns) {
      commit('columns/updateProject', { projectId, updated: { ...data.userCustomColumns } }, { root: true });
    }

    if (!data.isSpecialPaste) {
      commit('tasksModel/addTasks', { tasks: tasksModel.tasks }, { root: true });

      commit('tasksModel/updateTasks', { tasks: data.updatedTasks }, { root: true });
    } else {
      let tasksToUpdate = [];
      const needTasksUpdate = changedValues.some(value => OPTIONS_REQUIRED_TO_TASKS_UPDATE.includes(value));

      if (needTasksUpdate) {
        tasksToUpdate = tasksModel.tasks;
      }

      if (data.updatedTasks.length) {
        tasksToUpdate.push(...data.updatedTasks);
      }

      commit('tasksModel/updateTasks', { tasks: tasksToUpdate, fromGantt: false }, { root: true });
    }

    if (changedValues.includes('resources')) {
      const resourcesToTasks = Object.keys(data.pastedTasksData.resourcesToTasks).map(taskId => ({
        taskId: +taskId,
        ganttId: +projectId,
        resourcesToTask: data.pastedTasksData.resourcesToTasks[taskId],
      }));

      commit('tasksModel/updateResourcesToTasks', { resourcesToTasks, fromGantt: false }, { root: true });
    }

    if (data.copiedValues.includes('links') && tasksModel.links.length) {
      commit('tasksModel/addLinks', { links: tasksModel.links }, { root: true });
    }

    if (data.removedValues?.includes('links') && tasksModel.links.length) {
      commit('tasksModel/removeLinks', { links: tasksModel.links }, { root: true });
    }

    if (changedValues.includes('attachments')) {
      dispatch('attachments/fetchAttachmentsByProjectIds', {
        projectIds: data.newGanttId,
        refetch: true,
      }, { root: true });
    }

    if (changedValues.includes('comments')) {
      dispatch('comments/fetchCommentsByProjectIds', {
        projectIds: data.newGanttId,
        refetch: true,
      }, { root: true });
      dispatch('comments/fetchCommentsActions', null, { root: true });
    }
  },

  async updateConfig({ commit, state }, { projectId, updated = null }) {
    const updatedConfig = {
      ...state.copySettingsConfigsMap[projectId],
      ...updated,
    };

    await api.post('/task/copy-settings', updatedConfig);

    commit('updateConfig', { projectId, updated });
  },

  async applyCopyDataByOptions({ state }, data) {
    try {
      await api.post('/task/copy-by-options', {
        copyData: state.copiedTask,
        taskMap: state.taskMap,
        copyOptions: data.copyOptions,
        removeOptions: data.removeOptions,
        links: data.links,
      });
    } catch (error) {
      console.error(error);
    }
  },
};
